import { useState } from "react";
import { Icons } from "../../../utils/icons";
import EventSlotDetailCard from "./EventSlotDetailCard";
import ParticipantsCard from "./ParticipantsCard";
import AvailableUsersCard from "./AvailableUsersCard";
import RecurrenceCard from "./RecurrenceCard";

export default function EventSlotLayout({
  loading,
  onCancel,
  onSubmit,
  form,
  submitting,
  eventTypeOptions,
  data,
  displayedParticipants,
  availableUsers,
  currentUserId,
  recurrence,
  onRecurrenceChange,
  onDeleteRecurrence,
  recurrenceError,
}) {
  const [openSections, setOpenSections] = useState({
    details: true, // Ouvert par défaut
    participants: false,
    recurrence: false,
  });

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  if (loading) {
    return <div className="modal-overlay">Chargement…</div>;
  }

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal modal--lg" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <h2>
            <Icons.Calendar />
            {form.isEditing ? "Modifier l'événement" : "Créer un événement"}
          </h2>
          <button className="btn btn-icon-modern" onClick={onCancel}>
            <Icons.X />
          </button>
        </div>

        {/* Body avec accordéons */}
        <div className="modal-body">
          <form onSubmit={onSubmit}>
            <div className="accordion-sections">
              {/* SECTION 1 : Détails */}
              <section
                className={`accordion-section ${openSections.details ? "open" : ""}`}
              >
                <button
                  type="button"
                  className="accordion-header"
                  onClick={() => toggleSection("details")}
                >
                  <div className="accordion-header-left">
                    <Icons.Info />
                    <h3>Détails de l'événement</h3>
                  </div>
                  <Icons.ChevronDown
                    className={`accordion-icon ${openSections.details ? "rotated" : ""}`}
                  />
                </button>

                {openSections.details && (
                  <div className="accordion-content">
                    <EventSlotDetailCard
                      formData={form.formData}
                      errors={form.errors}
                      handleChange={form.handleChange}
                      toggleInstructor={form.toggleInstructor}
                      instructors={data.teachers}
                      eventTypeOptions={eventTypeOptions}
                    />
                  </div>
                )}
              </section>

              {/* SECTION 2 : Participants */}
              <section
                className={`accordion-section ${openSections.participants ? "open" : ""}`}
              >
                <button
                  type="button"
                  className="accordion-header"
                  onClick={() => toggleSection("participants")}
                >
                  <div className="accordion-header-left">
                    <Icons.Users />
                    <h3>Participants</h3>
                    <span className="badge-count">
                      {displayedParticipants.length}
                    </span>
                  </div>
                  <Icons.ChevronDown
                    className={`accordion-icon ${openSections.participants ? "rotated" : ""}`}
                  />
                </button>

                {openSections.participants && (
                  <div className="accordion-content">
                    <div className="participants-grid">
                      <ParticipantsCard
                        participants={displayedParticipants}
                        currentUserId={currentUserId}
                        onStatusChange={form.updateParticipantStatus}
                        onRemove={form.toggleParticipant}
                      />

                      <AvailableUsersCard
                        users={availableUsers}
                        onAddUser={form.toggleParticipant}
                      />
                    </div>
                  </div>
                )}
              </section>

              {/* SECTION 3 : Récurrence */}
              <section
                className={`accordion-section ${openSections.recurrence ? "open" : ""}`}
              >
                <button
                  type="button"
                  className="accordion-header"
                  onClick={() => toggleSection("recurrence")}
                >
                  <div className="accordion-header-left">
                    <Icons.Repeat />
                    <h3>Récurrence</h3>
                    {recurrence && recurrence.id && (
                      <span className="badge-active">Active</span>
                    )}
                    {recurrence && recurrence.isPending && (
                      <span className="badge-pending">Brouillon</span>
                    )}
                  </div>
                  <div className="accordion-header-right">
                    {recurrence && (
                      <button
                        type="button"
                        className="btn btn-icon-modern btn-danger-ghost"
                        onClick={(e) => {
                          e.stopPropagation(); // Empêche l'ouverture/fermeture
                          onDeleteRecurrence(recurrence.id);
                        }}
                        title="Supprimer la récurrence"
                      >
                        <Icons.Delete />
                      </button>
                    )}
                    <Icons.ChevronDown
                      className={`accordion-icon ${openSections.recurrence ? "rotated" : ""}`}
                    />
                  </div>
                </button>

                {openSections.recurrence && (
                  <div className="accordion-content">
                    <RecurrenceCard
                      recurrence={recurrence}
                      onChange={onRecurrenceChange}
                      onDelete={onDeleteRecurrence}
                      saveError={recurrenceError}
                    />
                  </div>
                )}
              </section>
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            disabled={submitting}
          >
            Annuler
          </button>
          <button
            className="btn btn-primary"
            disabled={submitting}
            onClick={onSubmit}
          >
            <Icons.Save /> Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}
